export default __webpack_public_path__ + "static/media/experience.8b28542e.svg";